/** tm/legal/useReadAll.ts — 「모두 확인」: 한 번에 읽음 처리 → 토스트 「되돌리기」(5초). 서버가 id 를 주면 /alerts/unread, 아니면 보이던 항목을 하나씩 되돌린다 */
import { useCallback } from 'react';
import { readAllAlerts, unreadAlerts, markRead } from './legalApi';
import { errMsg } from './legalTheme';
import { kindOf } from './alertUtil';
import type { LegalAlertsState } from './useLegalAlerts';
import type { ShowToast } from './legalUi';
import type { LegalAlerts, ReadAllIds } from './legalTypes';

function idsFrom(d: LegalAlerts): ReadAllIds {
  const out: ReadAllIds = { legal: [], bill: [], notice: [], cabinet: [] };
  for (const g of d.groups) for (const it of g.items) out[kindOf(g.key) as keyof ReadAllIds].push(it.id);
  return out;
}

export function useReadAll(alerts: LegalAlertsState, toast: ShowToast, after: () => void): () => Promise<void> {
  const { data, set, refresh } = alerts;
  return useCallback(async () => {
    const before = data;
    try {
      const ids = await readAllAlerts();
      set({ ...before, total: 0, groups: [], top: [] });
      after();
      const undo = async () => {
        try {
          if (ids) await unreadAlerts(ids);
          else { const f = idsFrom(before); await Promise.all([...f.legal.map(i => markRead('legal', i, false)), ...f.bill.map(i => markRead('bill', i, false)), ...f.notice.map(i => markRead('notice', i, false)), ...f.cabinet.map(i => markRead('cabinet', i, false))]); }
          toast('되돌렸습니다');
        } catch (e) { toast(errMsg(e, '되돌리지 못했습니다'), 'error'); }
        await refresh(); after();
      };
      toast(`새 소식 ${before.total}건을 모두 확인했습니다`, 'ok', { label: '되돌리기', run: () => { undo(); } });
    } catch (e) { toast(errMsg(e, '처리하지 못했습니다'), 'error'); }
    refresh();
  }, [data, set, refresh, toast, after]);
}
